import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClientknowledgeComponent } from './clientknowledge.component';
import { IClientKnowledgeState } from '../store/clientKnowledge/state';
import { clientKnowledgeInitialState } from '../store/clientKnowledge/initialState';
import { ClientKnowledgeContainer } from './clientknowledge.container';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { syncLuxSliceToStorage } from '../shared/lux-storage-sync';
import { LoaderComponent } from '@roosevelt/common-ui-lib/loader';


@NgModule({
  declarations: [
    ClientknowledgeComponent, ClientKnowledgeContainer
  ],
  imports: [
    CommonModule,
    LoaderComponent
  ]
})
export class ClientknowledgeModule {
  constructor(lux: Lux<{ clientKnowledgeState: IClientKnowledgeState }>, injector: Injector) {
    const clientKnowledgeState = JSON.parse(sessionStorage.getItem('bmt-client-knowledge-state'));
    lux.register('clientKnowledgeState', clientKnowledgeState || clientKnowledgeInitialState);
    syncLuxSliceToStorage(
      lux,
      injector,
      sessionStorage,
      'bmt-client-knowledge-state',
      state => state.clientKnowledgeState
    );
  }
}
